import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const RequestConfigContext = createContext(null);
export const RequestConfig = ({ children, config }) => {
    return (_jsx(RequestConfigContext.Provider, { value: config, children: children }));
};
export function useRequestConfig() {
    return useContext(RequestConfigContext);
}
